<template>
  <div>
    <component v-if="view" :is="view"></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Painter from './Painter/main.vue'
import Dealer from './Dealer/main.vue'
export default {
  components: {
    Painter,
    Dealer
  },

  computed: {
    ...mapGetters(['selectedBot']),
    view() {
      if (this.$store.state.toadealerpage.includes(this.selectedBot.pageid)) {
        return 'Dealer'
      } else if (this.$store.state.toapainterpage.includes(this.selectedBot.pageid)) {
        return 'Painter'
      } else return false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/main.vue